import defaultAvatar from './avatar.svg';
import avatar1 from './avatar-1.svg';
import avatar2 from './avatar-2.svg';
import avatar3 from './avatar-3.svg';
import avatar4 from './avatar-4.svg';
import avatar5 from './avatar-5.svg';
import avatar6 from './avatar-6.svg';
import avatar7 from './avatar-7.svg';
import avatar8 from './avatar-8.svg';
import avatar9 from './avatar-9.svg';
import avatar10 from './avatar-10.svg';
import avatar11 from './avatar-11.svg';
import avatar12 from './avatar-12.svg';
import avatar13 from './avatar-13.svg';
import avatar14 from './avatar-14.svg';
import avatar15 from './avatar-15.svg';
import avatar16 from './avatar-16.svg';
import avatar17 from './avatar-17.svg';
import avatar18 from './avatar-18.svg';
import avatar19 from './avatar-19.svg';
import avatar20 from './avatar-20.svg';

const images = [
  defaultAvatar,
  avatar6,
  avatar20,
  avatar3,
  avatar11,
  avatar1,
  avatar7,
  avatar19,
  avatar13,
  avatar2,
  avatar16,
  avatar5,
  avatar4,
  avatar15,
  avatar12,
  avatar10,
  avatar14,
  avatar8,
  avatar17,
  avatar18,
  avatar9
];

export default images;
